export default __webpack_public_path__ + "static/office4-3x-f6e1681f1ef91d212767cdf987fbd962.jpg";